var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9643 19.5506C10.9774 17.0363 15.5686 10.9424 15.5686 7.51946C15.5686 3.36809 12.1938 0 8.03429 0C3.87473 0 0.5 3.36809 0.5 7.51946C0.5 10.9424 5.09121 17.0363 7.10428 19.5506C7.58694 20.1498 8.48164 20.1498 8.9643 19.5506ZM8.03429 10.0259C6.64908 10.0259 5.52286 8.90194 5.52286 7.51946C5.52286 6.13698 6.64908 5.01297 8.03429 5.01297C9.4195 5.01297 10.5457 6.13698 10.5457 7.51946C10.5457 8.90194 9.4195 10.0259 8.03429 10.0259Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.07b9a0f427a7d69734503b5fa0a04864.svg";
export { ForwardRef as ReactComponent };